export const NAMES_PATTERN = /^[a-zA-Z\s'àáèéìíòóúùÀÁÈÉÌÍÒÓÚÙâêôãõçÂÊÔÃÕÇüñÜÑ]{2,}$/g

export const EMAIL_PATTERN = /^[a-zA-Z0-9_!#$%&’*+/=?`{|}~^.-]+@[a-zA-Z0-9.-]+[.]{1,1}[a-zA-Z0-9]{2,}$/g

export const PHONE_NUMBER_PATTERN = /^(\+\d{1,3}( )?)?((\(\d{3}\))|\d{3})[- .]?\d{3}[- .]?\d{4}$|^(\+\d{1,3}( )?)?(\d{3}[ ]?){2}\d{3}$|^(\+\d{1,3}( )?)?(\d{3}[ ]?)(\d{2}[ ]?){2}\d{2}$/g



export function isEmpty (val: string | undefined | null) {
    try {
        return (
            val === undefined || 
            val === null || 
            (typeof val === 'string' && val.trim() === '') || 
            val === 'Seleziona'
        )
    } catch (e) {
        return true
    }
}


export function isValidEmail (val: string | undefined) {
    if (val !== undefined && !isEmpty(val)) {
        return isValid(val.toLocaleLowerCase(), EMAIL_PATTERN)
    }
    return false
}

export function isValidPhone(val: string | undefined){  
    if (val !== undefined && !isEmpty(val)) {
        return isValid(val, PHONE_NUMBER_PATTERN)
    }
    return false
}
  
export function isValidName(val: string | undefined){
    if (val !== undefined && !isEmpty(val)) {
        return isValid(val, NAMES_PATTERN)
    }
    return false;
}


function isValid (val : string | undefined, regexp: RegExp) {
    if ( isEmpty(val) ) {
        return false
    }

    const pattern: any = new RegExp(regexp)

    return pattern.test(val)
}